module.exports = __webpack_public_path__ + "img/login_google.2cbb68b9.svg";